<template>
  
 <div class="container" style="margin-top: 1em;">
    <div class="raw">
    <div class="col-1">
    </div>
    <div class="col-11">
      <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
      <v-row>
        <v-col cols="1">
          <JsonToExcel v-if="['A'].find(el=>el==store.state.user.groupe)"></JsonToExcel>
        </v-col>
         <v-col cols="1">
          <v-btn density="compact" @click="refreshPrices()" color="primary" ><v-icon icon="mdi-refresh"></v-icon></v-btn>   
        </v-col>
      </v-row>
        <div v-for="marque in store.state.articles">
          <div v-for="theme in marque">
            <h4 style="color:grey"> {{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].marque }} | {{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme }} </h4> 
            <Theme :theme="theme"></Theme>
            <br>
            <br>
          </div>
        </div>
    </div>
  </div> 
  <v-dialog v-model="progressDialog" width="auto"
  >
    <v-progress-circular :model-value="cpt" :rotate="360" :size="100" :width="15" color="danger">
      <template v-slot:default> {{ cpt }} % </template>
    </v-progress-circular>
  </v-dialog>
</div> 

</template>
<script setup>
  import Theme from './Theme.vue';
  import axios from 'axios'
  import {onMounted, ref } from 'vue'
  import store from './store'
  import JsonToExcel from './JsonToExcel.vue';
  let progressDialog=ref(false)
  let cpt=ref(0)
  async function refreshPrices(){
    progressDialog.value=true
    let max=Object.values(store.state.articles)
      .flatMap(marque => Object.values(marque))  // Récupère tous les objets trad
      .flatMap(theme => Object.keys(theme))      // Récupère toutes les clés des trad
      .length;
    let i=0            
    for(let marque in store.state.articles){
      for (let theme in store.state.articles[marque]){
        for (let ref in store.state.articles[marque][theme]){
          cpt.value=100*(i/max).toFixed(2)
          await refreshPrice(store.state.articles[marque][theme][ref])
          i++
        }
      }
    }
    progressDialog.value=false
  }
  async function getBarCodes(reference){
    let barCodes=''
    for (let barcode in reference ){
      barCodes=barCodes+`&barcodes=${reference[barcode].codebarre}`
    }
    return barCodes
  }
  async function refreshPrice(reference){
    let referenceCol= reference[Object.keys(reference)[0]]
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${store.state.etablissement}/selling-prices/v1?taxExcluded=false&date=${store.state.date}${ await getBarCodes(reference)}`, //
      
      
      headers: { 
        'Authorization': `Bearer ${store.state.token_y2}`, 
        'Content-Type': 'application/json'
      }
    };
    // console.log(config.url);
    axios.request(config)
    .then((response) => {
      for( let price in response.data.prices){
        // if(response.data.prices[price].periodId!=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo){
          if(response.data.prices[price].unitPrice.base!=response.data.prices[price].unitPrice.current){
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=response.data.prices[price].unitPrice.current.toFixed(1)
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=response.data.prices[price].periodId
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          }else{
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=0
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=''
            store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
          }
        // }
      }
    })
    .catch((error) => {
      //console.log(error);
    })  
  }
onMounted(() => {

    // getArticles()
  })


</script>